import { TrackingEvent, TrackingEventTypes } from '@cinch-nx/shared-analytics'
import { AiSearchApiResponse } from '../services/types'
import { extractTrackingInformation } from './utils'

export const AI_SEARCH_FOCUS_EVENT_STORAGE_KEY = 'ai-search-focus-event-tracked'

export const aiSearchInputFocusTrackingEvent: TrackingEvent = {
  eventName: `AiSearchInput - focus`,
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: 'click',
      category: 'ai-search',
      action: 'search_box_focus',
      label: 'search_box',
    },
  },
}

export const aiSearchInputSubmitTrackingEvent = (
  searchQuery: string,
  response: AiSearchApiResponse,
): TrackingEvent => {
  const { session_id, run_id, filterType, filterCount, filtersConcatenated } =
    extractTrackingInformation(response)
  return {
    eventName: `AiSearchInput - search query submit`,
    type: TrackingEventTypes.ADOBE,
    data: {
      event: {
        name: 'click',
        category: 'ai-search',
        action: 'submit',
        label: 'search_box',
        value: searchQuery,
        type: filtersConcatenated,
        filterType: filterType,
        run_id: run_id,
        session_id: session_id,
        filterCount: filterCount,
        ajsUserId: window.analytics?.user?.()?.id?.(),
        ajsAnonymousId: window.analytics?.user?.()?.anonymousId?.(),
      },
    },
  }
}
